import UI from "./UI.class"

export default class Modal {
    static instance: Modal = new Modal()
    private ui = UI.instance
    constructor() {
        this.init()
    }


    private init() {
        // this.setFormModalData()
        this.ui.modal && this.toggleFormButtonDisabledState()
        this.ui.modal && this.handleOpenModal()
        this.ui.modal && this.handleCloseModal()

    }

    private disableFormSubmitButton(): void {

        this.ui.signUpForm.forEach(form => {
            const submitBtn = form.querySelector("button[type=submit]")
            submitBtn?.setAttribute("disabled", "true")
        })
    }


    private toggleFormButtonDisabledState(): void {
        this.disableFormSubmitButton()
        this.ui.signUpForm.forEach(form => {
            const emailInput = form.querySelector(".emailInput") as HTMLInputElement
            emailInput?.addEventListener("input", (e) => {
                const target = e.currentTarget as HTMLInputElement
                if (target.value) {
                    target.closest(".signUp")?.querySelector('button[type=submit]')?.removeAttribute("disabled")
                } else {
                    target.closest(".signUp")?.querySelector('button[type=submit]')?.setAttribute("disabled", "true")
                }
            })

        })
    }

    private handleOpenModal(): void {
        this.ui.openModal.forEach(button => {

            button.addEventListener("click", (e) => {
                e.preventDefault()

                const buttonElement = e.currentTarget as HTMLElement
                const form = buttonElement.closest('.signUp') as HTMLElement
                const { modal, formModal } = this.ui

                const modalTitle = formModal.querySelector('h2') as HTMLElement
                const modalSummary = formModal.querySelector(".form-check-label") as HTMLElement
                const modalValue = formModal.querySelector('input[type="hidden"]') as HTMLInputElement
                const modalEmail = formModal.querySelector('input[type="email"') as HTMLInputElement

                modalTitle.textContent = form.dataset.modalTitle as string
                modalSummary.textContent = form.dataset.modalSummary as string
                modalValue.value = form.dataset.modalType as string

                form.querySelectorAll(".emailInput").forEach((input) => {
                    const inputValue = input as HTMLInputElement

                    modalEmail.value = inputValue.value

                })

                modal.show()

            })
        })
    }

    private handleCloseModal(): void {
        this.ui.closeModal.addEventListener("click", () => {
            this.ui.modal.close()
        })
    }
}
